import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from '@patternfly/react-core';
import { useContext } from 'react';
import { useFieldValue } from '../../hooks/field-value';
import { SchemaContext } from '../../providers/SchemaProvider';
import { FieldWrapper } from '../FieldWrapper';
import { KeyValue } from '../../KeyValue/KeyValue';
export const PropertiesField = ({ propName, required }) => {
    var _a, _b;
    const { schema } = useContext(SchemaContext);
    const { value, onChange, disabled } = useFieldValue(propName);
    const items = Object.entries(value !== null && value !== void 0 ? value : {});
    const title = (_a = schema.title) !== null && _a !== void 0 ? _a : propName.split('.').pop();
    return (_jsx(FieldWrapper, { propName: propName, required: required, title: _jsxs(_Fragment, { children: [title, " ", _jsx(Badge, { title: `${items.length} properties`, children: items.length })] }), type: "object", description: schema.description, defaultValue: (_b = schema.default) === null || _b === void 0 ? void 0 : _b.toString(), children: _jsx(KeyValue, { propName: propName, initialModel: value, onChange: onChange, disabled: disabled }) }));
};
//# sourceMappingURL=PropertiesField.js.map